export enum PromptEditingMode {
    TEXT, CHIPS
}
